import React, { useContext, useState } from 'react';
import { LoadingOverlay, openLoader, closeLoader } from 'components/loading-overlay/LoadingOverlay';

import { Btn } from 'components/btn/Btn';
import { SERVICE_UNAVAILABLE_MESSAGE } from 'config';
import { UserPlaidWrapper } from 'features/coordinator/enrollment/steps/PlaidButton/PlaidButton';
import { setUserAchAccountStatus } from 'common/api/e-comm/ach';
import { useBlackBoxValues } from 'modules/fraud-force/fraudForce';
import { useLocation } from 'react-router-dom';
import { PaymentOptionsContext } from '../context';

export const MicroTransactionsFlow = () => {
    const { loader, reloadAchInfo } = useContext(PaymentOptionsContext);
    const { retrieveBlackBox } = useBlackBoxValues();
    const params = new URLSearchParams(useLocation().search);
    const [isOAuth, setIsOAuth] = useState(Boolean(params.get('oauth_state_id')));

    const onPlaidLinkSuccess = async () => {
        openLoader(loader?.current as LoadingOverlay);
        const bbv = await retrieveBlackBox();
        const response = await setUserAchAccountStatus(bbv.blackBoxValue ?? '');
        await reloadAchInfo();
        closeLoader(loader?.current as LoadingOverlay);

        if (response.error) {
            alert({ message: SERVICE_UNAVAILABLE_MESSAGE });
        }
    };

    return (
        <div>
            <ul className="list-disc list-outside text-sm text text-grey-1 p-3 pl-0 ml-7">
                <li>
                    A $0.01 deposit from Plaid should appear in your bank account after 1-2 business
                    days. Return here to complete your setup by entering the code. (Hint: your code
                    is the first 3 letters after the #.)
                </li>
                <li>
                    If you encounter issues, please call Customer Support at 1-800-727-4715 Option
                    3.
                </li>
            </ul>
            <div className="mt-3">
                <UserPlaidWrapper
                    addressId={''}
                    onSuccess={onPlaidLinkSuccess}
                    isOAuth={isOAuth}
                    onExit={() => setIsOAuth(false)}
                >
                    {(openPlaid, isPlaidReady: boolean) => (
                        <Btn onClick={openPlaid} disabled={!isPlaidReady}>
                            Complete Setup
                        </Btn>
                    )}
                </UserPlaidWrapper>
            </div>
        </div>
    );
};
